import { getRequest, getRequestWithConfig } from './DataService';
import { Api, GloveBox } from '../constants';

/*   
  create specific ovp page data access methods, use the DataService 
  'getRequest' and 'postRequest' methods to make the actual 
  Http calls 
*/

// GET Calls

export const getOVPDataApi: any = (
  vehicleId: number,
  referenceType: string,
  env: string,
  appInsightCallback?: (params: any) => void
) => {
  const url: string = `${Api.GET_OVP_DATA_API_URI}${referenceType}/${vehicleId}`;
  return getRequest({ url });
};

export const getOVPMfeFeedDataApi: any = (
  vehicleId: number,
  referenceType: string,
  env: string,
  bucket: string,
  sarHighIntent?: string
) => {
  let url: string = `${Api.GET_OVP_MFE_FEED_API_URI}/${referenceType}/${vehicleId}`;
  if (bucket && bucket === 'treatment') {
    url += `?isSarExperiment=true`;
  }
  return getRequest({
    url,
    headers: {
      'X-CVNA-SARs-High-Intent': (sarHighIntent && JSON.stringify(sarHighIntent)) || '',
    },
  });
};

export const downloadDocument: any = (documentName: string, url: string, env: string) => {
  // Only Purchase Contract uses APIK host, other documents have APIM host in the URL present by default
  const isApimUrl = GloveBox.FileName.indexOf(documentName) === -1;
  return getRequestWithConfig(isApimUrl, url, env, { responseType: 'blob' });
};
